import q from 'q'

export default class ImagePreloader {
  public static preloadImage(path: string): Promise<HTMLImageElement> {
    if (! path) {
      throw new Error('path is a required string')
    }

    return new Promise((resolve, reject) => {
      const img = document.createElement('img')
      img.onerror = (err) => {
        reject(err)
      }

      img.onload = () => {
        resolve(img)
      }

      img.src = path
    })
  }

  public static preloadImages(paths: string[] | string) {
    if (typeof paths === 'string') {
      paths = [paths]
    }

    if (! Array.isArray(paths)) {
      throw new Error('paths must be an array of strings or a single string')
    }

    const promises: Array<Promise<HTMLImageElement>> = []

    paths.forEach((v) => {
      promises.push(ImagePreloader.preloadImage(v))
    })

    return q.allSettled(promises)
  }
}
